import { getStringErrors, getValidationErrorDictionary, getValidationErrors } from "../../../../logic/ValidationChecks/Validation";
import { ValidationCheck } from "../../../../stores/models/ValidationCheck";
import { ValidationError } from "../../../../stores/models/ValidationError";
import { OrganizationSignUpTermsOfServiceStepValues } from "../_interfaces/IOrganizationSignUpStepTypeValues";

const validationChecks: (stepValues: OrganizationSignUpTermsOfServiceStepValues) => ValidationCheck<OrganizationSignUpTermsOfServiceStepValues>[] =
    (stepValues) => [{
        name: 'terms of service accepted',
        condition: (stepValues: OrganizationSignUpTermsOfServiceStepValues) => {
            return stepValues.termsOfServiceAccepted;
        },
        error: new ValidationError('Please review and accept the Terms of Service to continue.', ['termsOfServiceAccepted'])
    }];

export const OrganizationSignUpTermsOfServiceValidation = (stepValues: OrganizationSignUpTermsOfServiceStepValues) => {
    return {
        errors: getStringErrors(getValidationErrorDictionary(validationChecks, stepValues)),
        valid: getValidationErrors(validationChecks, stepValues).length === 0
    }
}